import { render, staticRenderFns } from "./AddWidgetCard.vue?vue&type=template&id=dd27cbfc&scoped=true&"
import script from "./AddWidgetCard.vue?vue&type=script&lang=js&"
export * from "./AddWidgetCard.vue?vue&type=script&lang=js&"
import style0 from "./AddWidgetCard.vue?vue&type=style&index=0&id=dd27cbfc&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dd27cbfc",
  null
  
)

export default component.exports